import { put } from 'redux-saga/effects';
import SitesActions from '../redux/SitesRedux';
import i18n from '../i18n';
import decode from 'jwt-decode';

export function* getSites(api, { customerId, pageParams }) {
  try {
    const getSitesResponse = yield api.getSites(customerId, pageParams);
    // console.log('getSitesResponse:', getSitesResponse);
    if (getSitesResponse.ok) {
      yield put(
        SitesActions.getSitesRequestSuccess(getSitesResponse.data.content, getSitesResponse.data.totalElements)
      );
    } else {
      api.checkAuth(getSitesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getSitesResponse.problem !== 'undefined'
          ? getSitesResponse.problem
          : typeof getSitesResponse.data.error !== 'undefined'
          ? getSitesResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.getSitesRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.getSitesRequestFailure(error));
  }
}

export function* getAllSites(api, { customerId, pageParams }) {
  try {
    const getAllSitesResponse = yield api.getSites(customerId, pageParams);
    if (getAllSitesResponse.ok) {
      const sitesWithSub = getAllSitesResponse.data.content.map((site) => ({ ...site, sub: decode(site.siteId).sub }));
      yield put(SitesActions.getAllSitesRequestSuccess(sitesWithSub, getAllSitesResponse.data.totalElements));
    } else {
      api.checkAuth(getAllSitesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getAllSitesResponse.problem !== 'undefined'
          ? getAllSitesResponse.problem
          : typeof getAllSitesResponse.data.error !== 'undefined'
          ? getAllSitesResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.getAllSitesRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.getAllSitesRequestFailure(error));
  }
}

export function* createSite(api, { siteInfos, customerId, pageParams }) {
  console.log('siteInfos:', siteInfos);
  try {
    const createSiteResponse = yield api.createSite(siteInfos);
    console.log('createSiteResponse:', createSiteResponse);
    const getSitesResponse = yield api.getSites(customerId, pageParams);
    const successMessage = i18n.t('successMessage.createSiteSuccess');
    console.log('getSitesResponse:', getSitesResponse);
    if (createSiteResponse.ok && getSitesResponse.ok) {
      yield put(
        SitesActions.createSiteRequestSuccess(
          createSiteResponse.data.siteId,
          createSiteResponse.data.address.addressId,
          getSitesResponse.data.content,
          getSitesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createSiteResponse);
      api.checkAuth(getSitesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createSiteResponse.problem !== 'undefined'
          ? createSiteResponse.problem
          : typeof createSiteResponse.data.error !== 'undefined'
          ? createSiteResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.createSiteRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.createSiteRequestFailure(error));
  }
}

export function* editSite(api, { siteInfos, customerId, pageParams }) {
  console.log('siteInfos:', siteInfos);
  try {
    const editSiteResponse = yield api.editSite(siteInfos);
    console.log('editSiteResponse:', editSiteResponse);
    const getSitesResponse = yield api.getSites(customerId, pageParams);
    const successMessage = i18n.t('successMessage.editSiteSuccess');
    console.log('getSitesResponse:', getSitesResponse);
    if (editSiteResponse.ok && getSitesResponse.ok) {
      yield put(
        SitesActions.editSiteRequestSuccess(
          getSitesResponse.data.content,
          getSitesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editSiteResponse);
      api.checkAuth(getSitesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editSiteResponse.problem !== 'undefined'
          ? editSiteResponse.problem
          : typeof editSiteResponse.data.error !== 'undefined'
          ? editSiteResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.editSiteRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.editSiteRequestFailure(error));
  }
}

export function* deleteSite(api, { siteId, customerId, pageParams }) {
  console.log('siteId:', siteId);
  try {
    const deleteSiteResponse = yield api.deleteSite(siteId);
    console.log('deleteSiteResponse:', deleteSiteResponse);
    const getSitesResponse = yield api.getSites(customerId, pageParams);
    const successMessage = i18n.t('successMessage.deleteSiteSuccess');
    console.log('getSitesResponse:', getSitesResponse);
    if (deleteSiteResponse.ok && getSitesResponse.ok) {
      yield put(
        SitesActions.deleteSiteRequestSuccess(
          getSitesResponse.data.content,
          getSitesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteSiteResponse);
      api.checkAuth(getSitesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteSiteResponse.problem !== 'undefined'
          ? deleteSiteResponse.problem
          : typeof deleteSiteResponse.data.error !== 'undefined'
          ? deleteSiteResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.deleteSiteRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.deleteSiteRequestFailure(error));
  }
}

export function* getSiteControllers(api, { siteId }) {
  try {
    const getSiteControllersResponse = yield api.getSiteControllers(siteId);
    console.log('getSiteControllersResponse:', getSiteControllersResponse);
    if (getSiteControllersResponse.ok) {
      yield put(SitesActions.getSiteControllersRequestSuccess(getSiteControllersResponse.data));
    } else {
      api.checkAuth(getSiteControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getSiteControllersResponse.problem !== 'undefined'
          ? getSiteControllersResponse.problem
          : typeof getSiteControllersResponse.data.error !== 'undefined'
          ? getSiteControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.getSiteControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.getSiteControllersRequestFailure(error));
  }
}

export function* editSiteController(api, { controllerId, controllerInfos, siteId }) {
  try {
    const editSiteControllerResponse = yield api.editController(controllerId, controllerInfos);
    console.log('editSiteControllerResponse:', editSiteControllerResponse);
    const getSiteControllersResponse = yield api.getSiteControllers(siteId);
    console.log('getSiteControllersResponse:', getSiteControllersResponse);
    const successMessage = i18n.t('successMessage.editDoorName');

    if (editSiteControllerResponse.ok && getSiteControllersResponse.ok) {
      yield put(SitesActions.editSiteControllerRequestSuccess(getSiteControllersResponse.data, successMessage));
    } else {
      api.checkAuth(editSiteControllerResponse);
      api.checkAuth(getSiteControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editSiteControllerResponse.problem !== 'undefined'
          ? editSiteControllerResponse.problem
          : typeof editSiteControllerResponse.data.error !== 'undefined'
          ? editSiteControllerResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.editSiteControllerRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.editSiteControllerRequestFailure(error));
  }
}

export function* deleteSiteController(api, { siteId, data }) {
  try {
    const deleteSiteControllerResponse = yield api.deleteSiteController(siteId, data);
    console.log('deleteSiteControllerResponse:', deleteSiteControllerResponse);
    const getSiteControllersResponse = yield api.getSiteControllers(siteId);
    const successMessage = i18n.t('successMessage.deleteSiteController');
    console.log('getSiteControllersResponse:', getSiteControllersResponse);
    if (deleteSiteControllerResponse.ok && getSiteControllersResponse.ok) {
      yield put(SitesActions.deleteSiteControllerRequestSuccess(getSiteControllersResponse.data, successMessage));
    } else {
      api.checkAuth(deleteSiteControllerResponse);
      api.checkAuth(getSiteControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteSiteControllerResponse.problem !== 'undefined'
          ? deleteSiteControllerResponse.problem
          : typeof deleteSiteControllerResponse.data.error !== 'undefined'
          ? deleteSiteControllerResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.deleteSiteControllerRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.deleteSiteControllerRequestFailure(error));
  }
}

export function* getSiteAvailableControllers(api, { pageParams, customerId }) {
  try {
    const getSiteAvailableControllersResponse = yield api.getSiteAvailableControllers(pageParams, customerId);
    console.log('getSiteAvailableControllersResponse:', getSiteAvailableControllersResponse);
    if (getSiteAvailableControllersResponse.ok) {
      yield put(
        SitesActions.getSiteAvailableControllersRequestSuccess(
          getSiteAvailableControllersResponse.data.content,
          getSiteAvailableControllersResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getSiteAvailableControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getSiteAvailableControllersResponse.problem !== 'undefined'
          ? getSiteAvailableControllersResponse.problem
          : typeof getSiteAvailableControllersResponse.data.error !== 'undefined'
          ? getSiteAvailableControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.getSiteAvailableControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.getSiteAvailableControllersRequestFailure(error));
  }
}

export function* getCustomerControllers(api, { customerId, pageParams }) {
  try {
    const getCustomerControllersResponse = yield api.getCustomerControllers(customerId, pageParams);
    if (getCustomerControllersResponse.ok) {
      const controllersWithSub = getCustomerControllersResponse.data.content.map((cont) => ({
        ...cont,
        sub: decode(cont.controllerId)?.sub,
      }));
      yield put(
        SitesActions.getCustomerControllersRequestSuccess(
          controllersWithSub,
          getCustomerControllersResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getCustomerControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getCustomerControllersResponse.problem !== 'undefined'
          ? getCustomerControllersResponse.problem
          : typeof getCustomerControllersResponse.data.error !== 'undefined'
          ? getCustomerControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.getCustomerControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.getCustomerControllersRequestFailure(error));
  }
}

export function* addControllerToSite(api, { siteId, data, customerId, distributorId }) {
  try {
    const addControllerToSiteResponse = yield api.addControllerToSite(siteId, data, customerId, distributorId);
    console.log('addControllerToSiteResponse:', addControllerToSiteResponse);
    const getSiteControllersResponse = yield api.getSiteControllers(siteId);
    const successMessage = i18n.t('successMessage.addDoor');
    console.log('getSiteControllersResponse:', getSiteControllersResponse);
    if (addControllerToSiteResponse.ok && getSiteControllersResponse.ok) {
      yield put(SitesActions.addControllerToSiteRequestSuccess(getSiteControllersResponse.data, successMessage));
    } else {
      api.checkAuth(addControllerToSiteResponse);
      api.checkAuth(getSiteControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof addControllerToSiteResponse.problem !== 'undefined'
          ? addControllerToSiteResponse.problem
          : typeof addControllerToSiteResponse.data.error !== 'undefined'
          ? addControllerToSiteResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(SitesActions.addControllerToSiteRequestFailure(error));
    }
  } catch (error) {
    console.log('error in sites saga', error);
    yield put(SitesActions.addControllerToSiteRequestFailure(error));
  }
}
